<template>
  <v-row class="main global">
    <v-col cols="12" class="main-body">
      <h1
        class="font-weight-light text-center primary--text"
        style="color: #007db6;"
      >
        {{ getGlobalTitle() }}
      </h1>
      <p class="text-center">{{ getGlobalSubtitle() }}</p>
      <v-img
        :aspect-ratio="16 / 9"
        :src="geographyTemplate.primaryImage"
      ></v-img>
      <v-row>
        <v-card
          v-for="index in geographyTemplate.factoidsState.length"
          :key="`factoid-${index}`"
          class="mx-auto"
          width="50%"
          flat
          tile
        >
          <v-card-text>
            <div class="subtitle-2">
              {{ getGlobalFactoid(index - 1, 'label') }}
            </div>
            <h2 class="primary--text font-weight-medium">
              {{ getGlobalFactoid(index - 1, 'value') }}
            </h2>
          </v-card-text>
        </v-card>
      </v-row>
      <v-row>
        <v-col>
          <p class="primary--text mb-1 mt-3">
            About {{ geographyTemplate.primaryCompany }}
          </p>
          <p class="body-2 mb-1 pre-wrap">
            {{
              geographyTemplate.companyInfos[geographyTemplate.primaryCompany]
            }}
          </p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import numeralHelper from '@/helpers/NumeralHelper';
import { mapState, mapGetters } from 'vuex';
import factsheetLogic from '@/mixins/factsheetLogic';

export default {
  name: 'GlobalFactsheet',
  mixins: [factsheetLogic],

  methods: {
    getGlobalValue(field) {
      const locationData = this.geographyTemplate.locationData;
      if (locationData) {
        //GLOBAL
        const globalData = locationData.find(
          (x) => x.COUNTRY_NAME.toUpperCase() === 'GLOBAL'
        );
        if (globalData) {
          return globalData[field];
        }
      }
      return;
    },
    getGlobalTitle() {
      const maptemplate = this.$parent.mapTemplate;
      if (maptemplate) {
        return maptemplate.geographyPanelTitleGlobal.title;
      }
      return;
    },
    getGlobalSubtitle() {
      const maptemplate = this.$parent.mapTemplate;
      if (maptemplate) {
        return maptemplate.geographyPanelTitleGlobal.subtitle;
      }
    },
    getGlobalFactoid(i, field) {
      const factoids = this.geographyTemplate.factoidsState;
      if (factoids.length >= i + 1) {
        if (field === 'label') {
          return factoids[i].label;
        }

        const value = this.getGlobalValue(factoids[i].field.toUpperCase());
        const formattedValue = numeralHelper.getFormattedNumber(
          value,
          factoids[i].field,
          'currencyFormat'
        );
        return formattedValue;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pre-wrap {
  white-space: pre-line;
  word-wrap: break-word;
  font-family: inherit;
}
</style>
